// extracted by mini-css-extract-plugin
export default {"ss-lottie-container":"ss-lottie-container_2K92u"};